import Config from '../Config.js';
import { merge } from 'lodash';

const APP_KEY = 'maptool';

function getLocalStorage(key) {
  return JSON.parse(localStorage.getItem(`${APP_KEY}_${key}`));
}

function setLocalStorage(key, value) {
  localStorage.setItem(`${APP_KEY}_${key}`, JSON.stringify(value));
}

export function getUrlParamsFromUrl(matchProps) {
  const matchParams = matchProps.params || matchProps.match.params;

  const urlParams = {
    urlParams: Object.assign(
      {},
      {
        optional: [],
        basemap: [],
        geo: [],
      },
      (
        (matchProps.location.hash || '').substring(1).split(';').map((a) => {
          const b = a.split(':');
          const d = (b.length === 2 && b[1] !== '') ? {
            [b[0]]: b[1].split(',').map(c => c)
          } : {};
          return d;
        })
        .reduce((prev, curr) => Object.assign(prev, curr), {
          productId: matchParams.productId || Config.DEFAULT_PRODUCT_ID,
          stateId: matchParams.stateId ? matchParams.stateId.substr(matchParams.productId.length + 1) : '',
        })
      )
    )
  };

  const localStorageParams = getLocalStorage('urlParams');

  if (urlParams.urlParams.stateId && localStorageParams) {
    delete localStorageParams.geo;
  }

  const mergedParams = merge(localStorageParams, urlParams.urlParams);

  return {
    urlParams: mergedParams
  };
}

export function composeUrlFromUrlParams(paramObject, paramType, paramValue) {
  const urlParams = paramObject;
  if (Object.prototype.toString.call(urlParams[paramType]) === '[object Array]') {
    if (paramType === 'optional') {
      const posInArray = urlParams[paramType].indexOf(paramValue);
      if (posInArray > -1) {
        urlParams[paramType].splice(posInArray, 1);
      } else {
        urlParams[paramType].push(paramValue);
      }
      urlParams[paramType] = urlParams[paramType].filter(i => i !== '');
    } else {
      urlParams[paramType] = [paramValue];
      if (paramType === 'geo') {
        urlParams[paramType] = paramValue;
      }
    }
  } else {
    urlParams[paramType] = paramValue;
  }
  let url = `/wetterkarten/${urlParams.productId}/`;
  if (urlParams.stateId) {
    url += `${urlParams.productId}-${urlParams.stateId}/`;
  }

  if (urlParams.optional || urlParams.basemap || urlParams.geo) {
    const p = ['optional', 'basemap', 'geo'].map(t =>
      (urlParams[t].length > 0 ? `${t}:${urlParams[t].join(',')}` : '')
    )
    .filter((q) => q !== '')
    .join(';');
    url += `#${p}`;
  }
  setLocalStorage('urlParams', urlParams);
  // console.log(`%c${url}`, 'background:black;color:white;font-size:20px;');
  return url;
}



/** WEBPACK FOOTER **
 ** ./apps/maptool/components/UrlUtils.js
 **/